export default (item, index) => ({
  name: `group${index}`,
  data: item.collection,
  label: item.label
})